import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import Selectsearch from "react-select";
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {

   deleteTournamentScore,
   studentTournamentScore,
   fetchTournamentScore,
   allStudents,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import EditItem from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class captoreport extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            listdiv:false,
            adddiv:false,
            editdiv:false,
            club:'', 
            tournament:'',
            seldate:'', 
            student:'',       
            country:'',
            round1date:'',
            round2date:'',
            round3date:'',
            round4date:'',
            view1:false,
            view2:false,
            view3:false,
            view4:false,
            missedcut:0,
            position:0,
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

   UNSAFE_componentWillMount() {
      this.props.allStudents();
	}

   onAddSession() {
		this.setState({
         viewdiv:false,
         listdiv:false,
         editdiv:false,
         adddiv:true,
      });
   } 
      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         viewdiv:true,
         listdiv:true,
       });
	}
   
   selstudent = (evt) =>{
      var stdid=evt.value;
      this.setState({ student:stdid });
      var start='';
      var end='';
      this.props.studentTournamentScore(stdid, start, end).then((data) => {   
         
         this.setState({ 
             listdiv:true,               
             adddiv:false,
             editdiv:false,
         });

     });
   }


   editAssessment(assmval){
        
      var id=assmval.gtrID;
        
        this.props.fetchTournamentScore(id).then((data) => {   
            var resdata=data.data;
            
            this.setState({ 
                student:resdata[0].gtr_userID,
                club:resdata[0].gtr_course,
                tournament:resdata[0].gtr_tournament,
                country:resdata[0].gtr_country,
                round1date:resdata[0].gtr_rddate1,
                round2date:resdata[0].gtr_rddate2,
                round3date:resdata[0].gtr_rddate3,
                round4date:resdata[0].gtr_rddate4,
                view1:true,
                view2:(resdata[0].gtr_round >=2)?true:false,
                view3:(resdata[0].gtr_round >=3)?true:false,
                view4:(resdata[0].gtr_round >=4)?true:false,
                missedcut:resdata[0].gtr_misscut,
                position:resdata[0].gtr_misscut,
            });

            this.setState({ 
                viewdiv:false,  
                listdiv:false,              
                adddiv:false,
                editdiv:true,
            });

        });
    }

   deleteForm(assmval){
      this.id = assmval.gtrID;
      this.usrid = assmval.gtr_userID;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse){
      
         if (popupResponse) {
            this.props.deleteTournamentScore(this.id, this.usrid);
            this.data = ""
         }
   }
   

    render() {
      const { match, studentlists, tournamentscorelist, loading } = this.props;
      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });
      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
      };

      const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "tournament", label: "TOURNAMENT" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
          
      ];
        const tabledata=tournamentscorelist.map((assmntval,idx) => {     
               const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
               const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                  no:idx+1,
                  name: assmntval.student,
                  cdate: assmntval.cdate,
                  tournament: assmntval.gtl_name,
                  action: ebtn,
                  action1:dbtn,
                
                }
        });  

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Tournament Score | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.tournamentscore" />} match={match} />
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}> 
                        <Label for="Select">Student *</Label> 
                        <FormGroup>   
                           <Label for="Select">Student *</Label>                                           
                           <Selectsearch id="student" name="student" placeholder="Select..." options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                        </FormGroup>
                  </div>
               }                          
               {this.state.listdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Test</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                  <EditItem onClick={this.onBackSection} data={this.state}/>              
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'tournament score'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, tournamentscore }) => {
   const { studentlists } = mostlyused;
	const { tournamentscorelist, loading } = tournamentscore;
	return { studentlists, tournamentscorelist, loading };
}

export default connect(mapStateToProps, {
 
   deleteTournamentScore,
   studentTournamentScore,
   fetchTournamentScore,
   allStudents
})(captoreport); 